<script>
    import {createEventDispatcher} from "svelte";

    export let messages = [
        {
            message: "Print job queued",
            time: "11:45:32"
        },
        {
            message: "Print job in progress",
            time: "11:45:34"
        },
        {
            message: "Print job finished",
            time: "11:45:36",
            level: "success"
        },
        {
            message: "Print failed",
            time: "11:45:36",
            level: "error"
        }
    ];
    export let showDismiss;

    let container;

    $: if (messages && container) {
        container.scrollTop = container.scrollHeight;
    }

    const dispatch = createEventDispatcher();

    function dismiss() {
        dispatch('dismiss', {});
    }
</script>

<div class="print-status-head">
    <h5 class="flex-1">Print status</h5>
    <button class="pull-right btn-rounded"
            class:invisible={!showDismiss}
            on:click={dismiss}>Dismiss</button>
</div>

{#if messages.length}
    {@const message = messages[messages.length - 1]}
    <div class="messages-outer" bind:this={container}>
        <ul class="list-group">
            <li class="list-group-item">
                <span class="message-content">
                    {message.message}
                    ..{#if messages.length % 2}.{/if}
                </span>
            </li>
        </ul>
    </div>
{/if}

<style>
    .print-status-head {
        margin-bottom: 4px;
        display: flex;
    }

    .invisible {
        visibility: hidden;
    }

    .messages-outer {
        width: 100%;
    }

    ul {
        list-style: none;
        display: block;
        padding: 0;
        margin: 0;
        width: auto;
    }

    li {
        list-style: none;
        padding: 0.25rem 0.5rem;
        margin: 0;
        white-space: nowrap;
        line-height: 1.2;
    }
</style>